// @ts-nocheck
/**
 * Mood board: horizontal product-image tracks, desktop carousel, optional mobile strip,
 * lightbox, keyboard scroll, reduced-motion, copy/share link.
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
  }

  function scrollBehavior() {
    return prefersReducedMotion() ? 'auto' : 'smooth';
  }

  function initTrack(track) {
    const media = track.closest('.mood-board__media');
    if (!media) return;
    const prev = media.querySelector('[data-mood-board-prev]');
    const next = media.querySelector('[data-mood-board-next]');
    if (!prev || !next) return;

    const step = () => Math.max(1, Math.round(track.clientWidth * 0.85));

    const updateDisabled = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: scrollBehavior() });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: scrollBehavior() });
    });

    track.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        updateDisabled();
      },
      { passive: true }
    );
    updateDisabled();
    initGalleryLoadMore(media);
    bindKeyboardScroll(track, step);
  }

  /**
   * Progressive slider: reveal hidden slides when "Load more" is tapped.
   * @param {HTMLElement} media - .mood-board__media
   */
  function initGalleryLoadMore(media) {
    const btn = media.querySelector('[data-mood-board-gallery-load-more]');
    if (!(btn instanceof HTMLButtonElement)) return;

    btn.addEventListener('click', () => {
      const track = media.querySelector('[data-mood-board-track]');
      const prev = media.querySelector('[data-mood-board-prev]');
      const next = media.querySelector('[data-mood-board-next]');
      if (!track) return;

      const chunk = Math.max(1, parseInt(btn.getAttribute('data-load-more-chunk') || '4', 10) || 4);
      const pending = track.querySelectorAll('.mood-board__slide[data-mood-board-deferred][hidden]');
      if (pending.length === 0) {
        btn.hidden = true;
        return;
      }

      let n = 0;
      for (const slide of pending) {
        if (n >= chunk) break;
        slide.removeAttribute('hidden');
        slide.removeAttribute('data-mood-board-deferred');
        n++;
      }

      const maxScroll = track.scrollWidth - track.clientWidth;
      if (prev instanceof HTMLButtonElement) prev.disabled = track.scrollLeft <= 1;
      if (next instanceof HTMLButtonElement) next.disabled = track.scrollLeft >= maxScroll - 1;

      if (track.querySelectorAll('.mood-board__slide[data-mood-board-deferred][hidden]').length === 0) {
        btn.hidden = true;
      }
    });
  }

  function initCarousel(scroller) {
    const cells = scroller.querySelectorAll('.mood-board__cell');
    if (cells.length <= 1) return;

    const step = () => {
      const first = cells[0];
      if (!first) return scroller.clientWidth;
      const rect = first.getBoundingClientRect();
      const style = window.getComputedStyle(scroller);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      return rect.width + gap;
    };

    const prev = scroller.parentElement?.querySelector('[data-mood-carousel-prev]');
    const next = scroller.parentElement?.querySelector('[data-mood-carousel-next]');
    if (!prev || !next) return;

    const updateDisabled = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= max - 1;
    };

    prev.addEventListener('click', () => {
      scroller.scrollBy({ left: -step(), behavior: scrollBehavior() });
    });
    next.addEventListener('click', () => {
      scroller.scrollBy({ left: step(), behavior: scrollBehavior() });
    });

    scroller.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled, { passive: true });
    updateDisabled();
    bindKeyboardScroll(scroller, step);
  }

  /**
   * @param {HTMLElement} el
   * @param {() => number} getStep
   */
  function bindKeyboardScroll(el, getStep) {
    if (!el || el.dataset.moodKeyboardScroll === '1') return;
    el.dataset.moodKeyboardScroll = '1';

    el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        el.scrollBy({ left: getStep(), behavior: scrollBehavior() });
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        el.scrollBy({ left: -getStep(), behavior: scrollBehavior() });
      } else if (e.key === 'Home') {
        e.preventDefault();
        el.scrollTo({ left: 0, behavior: scrollBehavior() });
      } else if (e.key === 'End') {
        e.preventDefault();
        el.scrollTo({ left: el.scrollWidth, behavior: scrollBehavior() });
      }
    });
  }

  function initLightbox(root) {
    root.querySelectorAll('[data-mood-board-lightbox-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const cell = btn.closest('.mood-board__cell');
        const dialog = cell?.querySelector('[data-mood-board-lightbox]');
        const img = dialog?.querySelector('.mood-board-lightbox__img');
        if (!(dialog instanceof HTMLDialogElement) || !(img instanceof HTMLImageElement)) return;

        const src = btn.getAttribute('data-lightbox-src') || '';
        const alt = btn.getAttribute('data-lightbox-alt') || '';
        const w = btn.getAttribute('data-lightbox-width');
        const h = btn.getAttribute('data-lightbox-height');
        img.src = src;
        img.alt = alt;
        if (w) img.width = parseInt(w, 10) || 1200;
        if (h) img.height = parseInt(h, 10) || 1200;
        dialog.showModal();
      });
    });

    root.querySelectorAll('[data-mood-board-lightbox]').forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;
      dialog.querySelectorAll('[data-mood-board-lightbox-close]').forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (ev) => {
        if (ev.target === dialog) dialog.close();
      });
      dialog.addEventListener('cancel', (ev) => {
        ev.preventDefault();
        dialog.close();
      });
    });
  }

  function initShare(root) {
    const btn = root.querySelector('[data-mood-board-copy-link]');
    if (!(btn instanceof HTMLButtonElement)) return;
    const url =
      root.getAttribute('data-mood-board-share-url') ||
      `${window.location.origin}${window.location.pathname}`;
    const feedback = root.querySelector('[data-mood-board-copy-feedback]');

    btn.addEventListener('click', async () => {
      const title = document.title || '';
      const showCopied = () => {
        if (feedback) {
          feedback.hidden = false;
          window.setTimeout(() => {
            feedback.hidden = true;
          }, 2200);
        }
      };
      try {
        if (navigator.share) {
          try {
            await navigator.share({ url, title });
            return;
          } catch {
            /* dismissed or unsupported fields — fall through to copy */
          }
        }
        await navigator.clipboard.writeText(url);
        showCopied();
      } catch {
        try {
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showCopied();
        } catch {
          /* ignore */
        }
      }
    });
  }

  /**
   * Wrapped grid: show first N tiles (from section data on expand wrap); toggle reveals/hides the rest.
   */
  function initGridCollapse(root) {
    const wrap = root.querySelector('[data-mood-grid-expand-wrap]');
    if (!wrap) return;

    const scroller = root.querySelector('[data-mood-board-carousel]');
    const btn = wrap.querySelector('[data-mood-grid-load-all]');
    if (!scroller || !btn) return;
    const shell = scroller.closest('.mood-board__carousel-shell');

    const limD = parseInt(wrap.getAttribute('data-mood-grid-initial-desktop') || '999', 10);
    const limM = parseInt(wrap.getAttribute('data-mood-grid-initial-mobile') || '999', 10);
    const showMoreText = btn.getAttribute('data-mood-show-more-text') || 'View more';
    const showLessText = btn.getAttribute('data-mood-show-less-text') || 'View less';
    const btnText = btn.querySelector('[data-mood-grid-toggle-text]');
    const btnKicker = btn.querySelector('[data-mood-grid-toggle-kicker]');
    const mq = window.matchMedia('(min-width: 750px)');

    let expanded = false;

    const cells = () => Array.from(scroller.querySelectorAll(':scope > .mood-board__cell'));
    scroller.setAttribute('data-mood-grid-managed', 'true');

    const limitFor = () => {
      if (mq.matches) {
        if (scroller.classList.contains('mood-board__grid--carousel')) return 999;
        return limD;
      }
      if (scroller.classList.contains('mood-board__grid--mobile-carousel')) return 999;
      return limM;
    };

    const clearPeekVars = () => {
      scroller.style.removeProperty('--mood-grid-fade-start');
    };

    const setCellClipped = (cell, clipped) => {
      if (clipped) cell.setAttribute('data-mood-grid-clipped', '');
      else cell.removeAttribute('data-mood-grid-clipped');
    };

    /*
     * Hidden when the section (or any ancestor) is `display:none`. This happens during the
     * first paint when the global brand-visibility CSS in theme.liquid hides a section whose
     * `data-brand-visible` doesn't match the server-rendered `body[data-active-brand]`.
     * In that state layout metrics are unreliable — skip clipping until brands.js flips the brand
     * and the MutationObserver re-runs apply().
     */
    const isLayoutHidden = () => scroller.offsetParent === null && getComputedStyle(scroller).position !== 'fixed';

    const apply = () => {
      const lim = limitFor();
      const list = cells();
      list.forEach((c) => c.removeAttribute('hidden'));
      if (lim >= list.length) {
        scroller.style.removeProperty('max-height');
        clearPeekVars();
        list.forEach((c) => setCellClipped(c, false));
        scroller.removeAttribute('data-mood-grid-collapsed');
        scroller.removeAttribute('data-mood-grid-expanded');
        shell?.removeAttribute('data-mood-grid-collapsed');
        shell?.removeAttribute('data-mood-grid-expanded');
        wrap.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        return;
      }

      if (expanded) {
        list.forEach((c) => setCellClipped(c, false));
        scroller.style.removeProperty('max-height');
        clearPeekVars();
        scroller.removeAttribute('data-mood-grid-collapsed');
        scroller.setAttribute('data-mood-grid-expanded', 'true');
        shell?.removeAttribute('data-mood-grid-collapsed');
        shell?.setAttribute('data-mood-grid-expanded', 'true');
        wrap.hidden = false;
        if (btnText) btnText.textContent = showLessText;
        else btn.textContent = showLessText;
        if (btnKicker) btnKicker.textContent = 'Back to the first edit';
        btn.setAttribute('aria-label', 'View fewer event photos');
        btn.setAttribute('aria-expanded', 'true');
        return;
      }

      if (isLayoutHidden()) {
        // Don't bake in a zero-height clamp; wait for the brand mutation to re-trigger.
        scroller.style.removeProperty('max-height');
        list.forEach((c) => setCellClipped(c, false));
        return;
      }

      list.forEach((c, i) => setCellClipped(c, i >= lim));
      scroller.style.removeProperty('max-height');
      scroller.setAttribute('data-mood-grid-collapsed', 'true');
      scroller.removeAttribute('data-mood-grid-expanded');
      shell?.setAttribute('data-mood-grid-collapsed', 'true');
      shell?.removeAttribute('data-mood-grid-expanded');
      wrap.hidden = false;
      if (btnText) btnText.textContent = showMoreText;
      else btn.textContent = showMoreText;
      if (btnKicker) {
        const remaining = Math.max(list.length - lim, 0);
        btnKicker.textContent = remaining === 1 ? '1 more event photo' : `${remaining} more event photos`;
      }
      btn.setAttribute('aria-label', 'View more event photos');
      btn.setAttribute('aria-expanded', 'false');
    };

    btn.addEventListener('click', () => {
      expanded = !expanded;
      apply();
    });

    mq.addEventListener('change', apply);
    window.addEventListener('resize', apply, { passive: true });

    /*
     * brands.js sets body[data-active-brand] on DOMContentLoaded after reading localStorage.
     * That can flip a brand-hidden section to visible AFTER the deferred mood-board.js
     * has already run apply() against a hidden subtree. Re-run when the brand changes.
     */
    if (typeof MutationObserver !== 'undefined') {
      const brandObserver = new MutationObserver(() => apply());
      brandObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-active-brand'],
      });
    }

    apply();
  }

  function initRoot(root) {
    root.querySelectorAll('[data-mood-board-track]').forEach(initTrack);
    root.querySelectorAll('[data-mood-board-carousel]').forEach(initCarousel);
    initGridCollapse(root);
    initLightbox(root);
    initShare(root);
  }

  document.querySelectorAll('[data-mood-board-root]').forEach(initRoot);

  document.addEventListener('shopify:section:load', (event) => {
    const t = event.target;
    if (!(t instanceof HTMLElement)) return;
    const root = t.querySelector('[data-mood-board-root]');
    if (root) initRoot(root);
  });
})();
